import StatusPage from './components/StatusPage';
import './css/main.css';
import './css/app.css';

function App() {
  return (
    <div className="app">
      <StatusPage />
    </div>
  );
}

export default App;
